import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../../Base/Components/BaseModal/BaseModal';
import ElectronicPrescriptionDetailLatamAddMedicamentForm, {
	ElectronicPrescriptionDetailLatamAddMedicamentFormValues,
} from './ElectronicPrescriptionDetailLatamAddMedicamentForm';

interface Props extends BaseModalProps {
	onSubmit: (
		values: ElectronicPrescriptionDetailLatamAddMedicamentFormValues,
	) => void;
	medicament?: ElectronicPrescriptionDetailLatamAddMedicamentFormValues;
}

const ElectronicPrescriptionDetailLatamAddMedicamentFormModal: React.FC<
	Props
> = props => (
	<BaseModal
		{...props}
		title='component.electronicPrescriptionDetailLatamAddMedicamentFormModal.title'>
		<ElectronicPrescriptionDetailLatamAddMedicamentForm
			onSubmit={props.onSubmit}
			medicament={props.medicament}
		/>
	</BaseModal>
);

export default ElectronicPrescriptionDetailLatamAddMedicamentFormModal;
